import { z } from 'zod'

export const cookieConsentAppSettingsSchema = z.object({
  version: z.string(),
})

export type CookieConsentAppSettings = z.infer<
  typeof cookieConsentAppSettingsSchema
>
